import React from 'react'
import { faNotesMedical } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, Space, theme, Typography, Input } from 'antd'

import { hexToRGBA } from '../../../../lib/utils'

const { Title, Text } = Typography

/**
 * SymptomsCapture Component
 * Allows users to select and manage symptoms for a booking
 * @param {Object} props
 * @param {Object} props.bookingData - Booking information containing ID and symptoms
 */
const SymptomsPatient = ({ bookingData }) => {
  const { token } = theme.useToken()

  return (
    <Card
      styles={{
        header: {
          background: hexToRGBA(token.colorPrimary, 0.08),
          borderBottom: `1px solid ${hexToRGBA(token.colorPrimary, 0.1)}`,
          padding: '12px 16px'
        },
        body: {
          padding: '16px'
        }
      }}
      size='small'
      title={
        <Space>
          <FontAwesomeIcon
            icon={faNotesMedical}
            style={{
              color: token.colorPrimary,
              fontSize: '16px'
            }}
          />
          <Title level={5} style={{ margin: 0 }}>
            Symptoms
          </Title>
          <Text type='secondary' style={{ margin: 0 }}>
            Patient Reported
          </Text>
        </Space>
      }
      style={{
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        overflow: 'hidden'
      }}
    >
      <Input defaultValue={bookingData?.chiefComplaint} style={{ width: '100%' }} readOnly />
    </Card>
  )
}

export default React.memo(SymptomsPatient)
